<template>
  <section
    id="sakiwari"
    class="te-bg-sakiwari text-center text-co-gray-50"
  >
    <div class="co-container-sm px-4 pb-10 pt-7">
      <img
        class="mx-auto mb-4 h-auto max-w-full sm:w-[70%] md:mt-[-3.25rem]"
        src="~/assets/images/Te/TeSet/Sakiwari/sakiwari-title.svg"
        loading="lazy"
        alt="先割"
      >
      <ClientOnly>
        <h2 class="co-display-10 mb-5 leading-base">
          <span class="block sm:inline">セット割を先行申込すると</span>
          <span class="block sm:inline">受講料が5％OFF！</span>
          <br>
          <span class="block sm:inline">このお得な割引を使って</span>
          <span class="block sm:inline">受講しよう！</span>
        </h2>
        <div class="flex flex-col items-center">
          <TeCommonBalloon
            v-show="isShowNotification"
            class="co-display-10 my-5 rounded border-[#008cee] bg-[#008cee]"
          >
            ＼ 残りわずか！お早めに ／
          </TeCommonBalloon>
          <b class="co-display-11 mb-6 inline-block border border-white px-4 py-2 font-normal tracking-[0.15em] md:mb-7">
            申込締切：
            <span class="font-bold">
              {{ closesMonth }}
            </span>
            月
            <span class="font-bold">
              {{ closesDays }}
            </span>
            日（{{ closesDayOfWeek }}）
            <span class="font-bold">
              {{ closesHours }}
            </span>
            時
          </b>
        </div>
        <div class="mb-8 rounded-t border-2 border-[#008cee] bg-white">
          <h3 class="co-display-11 bg-[#008cee] p-3 font-bold leading-base">
            現在受付中の受講開始日
          </h3>
          <div class="py-4 md:py-4">
            <ul class="m-0 flex list-none flex-col flex-wrap justify-center text-co-gray-700 sm:flex-row">
              <li v-show="isSakiwariCohortEmpty">
                現在、先割をご利用になれる参加日程がありません
              </li>
              <li
                v-for="cohort in sakiwariPacks"
                v-show="!isSakiwariCohortEmpty"
                class="co-display-11 mb-1 sm:mb-0 sm:mr-7"
              >
                <b class="font-bold">
                  第{{ cohort.number }}期
                </b>
                （ {{ ToMonthAndDay(cohort.begins_at) }} ）
              </li>
            </ul>
          </div>
        </div>
        <h3 class="co-display-10 mb-5 w-full text-center font-bold ">
          <FontAwesomeIcon
            :icon="faHandPointRight"
            class="fa-fw mr-3 inline"
          />
          先割のカンタンお申し込み
        </h3>
        <div class="flex flex-col items-center justify-center lg:mb-8 lg:flex-row">
          <div class="flex w-full flex-col rounded border-co-gray-950/[.125] bg-co-gray-50 p-5 text-co-gray-700">
            <h3 class="te-text-sakiwari-blue co-display-11 m-0 border-0 pb-4 pt-1 font-bold md:pb-3">
              参加日程を選ぶ
            </h3>
            <img
              class="mx-auto mb-4 block max-w-full"
              src="~/assets/images/Te/TeSet/Sakiwari/sakiwari-step1.jpg"
              loading="lazy"
              alt="参加日程を選ぶ"
            >
            <p class="co-display-12 mb-0 text-left">
              参加日程からご希望の先割対象日程をお選びください。
            </p>
          </div>
          <FontAwesomeIcon
            :icon="faChevronDown"
            class="fa-fw co-display-9 block py-2 opacity-70 lg:hidden"
          />
          <FontAwesomeIcon
            :icon="faChevronRight"
            class="fa-fw co-display-6 hidden px-2 opacity-70 lg:block"
          />
          <div class="mb-7 flex w-full flex-col rounded border-co-gray-950/[.125] bg-co-gray-50 p-5 text-co-gray-700 lg:mb-0">
            <h3 class="te-text-sakiwari-blue co-display-11 m-0 border-0 pb-4 pt-1 font-bold md:pb-3">
              申し込む
            </h3>
            <img
              class="mx-auto mb-4 block max-w-full"
              src="~/assets/images/Te/TeSet/Sakiwari/sakiwari-step3.jpg"
              loading="lazy"
              alt="申し込む"
            >
            <p class="co-display-12 mb-0 text-left text-gray-700">
              その他の必要事項をご記入の上、お申し込みください。
            </p>
          </div>
        </div>
        <a
          class="co-btn-ghost-white mb-6 rounded-full border"
          href="#apply"
          @click.prevent="scrollTo('apply')"
        >
          お申し込みフォームへ
        </a>
        <ul class="co-display-14 mb-0 text-left sm:text-center">
          <li>※先割の期間内に対象となる日程のセット割をお申し込みの方が対象になります。</li>
          <li>※お申し込み時の入金期限までに決済をされた方が対象となります。</li>
          <li>※その他のキャンペーン等との併用はできません。</li>
        </ul>
      </ClientOnly>
    </div>
  </section>
</template>

<script lang="ts">
import { scrollTo } from '~/composables/useSmoothScroll'
import { dateToYesterday, daysOfWeek } from '~/utility/utility'
import TeCommonBalloon from '~/components/Te/TeCommon/Balloon/TeCommonBalloon/TeCommonBalloon.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown, faChevronRight } from '@awesome.me/kit-65d95819ce/icons/classic/solid'
import { faHandPointRight } from '@awesome.me/kit-65d95819ce/icons/classic/regular'

interface Props {
  pack: any
}

const options = {
  async setup() {
    return {
      faChevronDown,
      faChevronRight,
      faHandPointRight,
    }
  },
  props: {
    pack: {
      default: null,
    },
  },
  methods: {
    ToMonthAndDay(value: string) {
      if (value) {
        const monthAndDay = /-(\d+-\d+)/.exec(value)![1]
        const newMonthAndDay = monthAndDay.replace('-', '/')
        return newMonthAndDay + '〜'
      } else {
        return '-'
      }
    },
  },
  computed: {
    closesAt(): Date | null {
      return this.pack ? new Date(this.pack.attributes.closes_at) : null
    },
    yesterdayClosesAt(): Date | null {
      return this.closesAt ? dateToYesterday(this.closesAt) : null
    },
    closesDays(): number | '-' {
      return this.yesterdayClosesAt ? this.yesterdayClosesAt.getDate() : '-'
    },
    closesMonth(): number | '-' {
      return this.yesterdayClosesAt
        ? this.yesterdayClosesAt.getMonth() + 1
        : '-'
    },
    closesHours(): number | '-' {
      return this.yesterdayClosesAt
        ? this.yesterdayClosesAt.getHours() + 24
        : '-'
    },
    closesDayOfWeek(): '日' | '月' | '火' | '水' | '木' | '金' | '土' | '-' {
      if (this.yesterdayClosesAt) {
        const dayOfWeek = daysOfWeek(this.yesterdayClosesAt)
        return dayOfWeek
      } else {
        return '-'
      }
    },
    isShowNotification(): boolean {
      if (this.closesAt === null) return false

      const date = new Date(this.closesAt)
      date.setDate(date.getDate() - 3)

      return date < new Date()
    },
    isSakiwariCohortEmpty(): boolean {
      if (this.pack && this.pack.attributes.sakiwari_packs.length !== 0) {
        return false
      } else {
        return true
      }
    },
    sakiwariPacks(): object[] {
      return this.pack ? this.pack.attributes.sakiwari_packs : []
    },
  },
  components: {
    TeCommonBalloon,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>

.te-bg-sakiwari {
  background-image: url('~/assets/images/Te/TeSet/Sakiwari/sakiwari.png');
}

.te-text-sakiwari-blue {
  color: #008cee;
}

.te-bg-sakiwari-blue {
  background-color: #008cee;
}

.te-border-sakiwari-blue {
  border-color: #008cee;
}
</style>
